import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

const oldMethod={
    state:{
        boatGlobal:[],
        boatGlobalSancion:[],
        dispatchFactor:[{
            navigate:0,
            activity:0
        }],
        shipRegisters:[],
        ufv:0,
        total_dispatch:0,
        disabled_global:false,
        token_dispatch:null,
        title_dispatch:null,
        userState:{
            nick:null,
            portId:null,
            name_port:null,
            category_port:null,
            role:0,
            roleAssign:null
        },
        dispatchDregde:[{
            job_days:0,
            is_dredge:false
        }],
        shipRegistersSancion:[],
        dispatchFactorSancion:[{
            navigate:0,
            activity:0
        }],
        helpNavigationFactor:0,
        total_dispatch_sancion:0,
        token_dispatch_sancion:null,
        is_sindicate:'N',
        days_sindicate:0
    },
    getters:{
        getHelpNavigate(state){
            return state.helpNavigationFactor;
        },
        getBoat(state){
            return state.boatGlobal;
        },
        getBoatSancion(state){
            return state.boatGlobalSancion;
        },
        getFactor(state){
            return state.dispatchFactor;
        },
        getFactorSancion(state){
            return state.dispatchFactorSancion;
        },
        getDredge(state){
            return state.dispatchDregde;
        },
        getTitleDispatch(state){
            return state.title_dispatch;
        },        
        getShips(state){
            return state.shipRegisters;
        },
        getShipsSancion(state){
            return state.shipRegistersSancion;
        },
        getUFV(state){
            return state.ufv;
        },
        getTotalDispatch(state){
            return state.total_dispatch;
        },
        getTotalDispatchSancion(state){
            return state.total_dispatch_sancion;
        },
        getDisabled(state){
            return state.disabled_global;
        },
        getUserState(state){
            return state.userState;
        }
    },
    mutations:{
        ADD_IS_SINDICATE:(state, payload)=>{
            state.is_sindicate=payload;
        },
        ADD_DAYS_SINDICATE:(state, payload)=>{
            state.days_sindicate=payload;
        },
        ADD_HELP_NAVIGATION:(state,payload)=>{
            state.helpNavigationFactor=payload;
        },
        ADD_BOAT:(state, payload) => {
            state.boatGlobal=payload
        },
        DELETE_BOAT:(state, payload)=>{
            state.boatGlobal=[]
        },
        DELETE_BOAT_SANCION:(state, payload)=>{
            state.boatGlobalSancion=[]
        },
        ADD_UFV:(state, payload)=>{
            state.ufv=payload;
        },
        ADD_FACTOR:(state, payload)=>{
            state.dispatchFactor=payload
        },
        DELETE_FACTOR:(state, payload)=>{
            state.dispatchFactor=[];
        },
        ADD_FACTOR_SANCION:(state, payload)=>{
            state.dispatchFactorSancion=payload
        },
        DELETE_FACTOR_SANCION:(state, payload)=>{
            state.dispatchFactorSancion=[];
        },
        ADD_DREDGE:(state, payload)=>{
            state.dispatchDregde=payload;
        },
        DELETE_DREDGE:(state, payload)=>{
            state.dispatchDregde=[];
        },
        ADD_SHIP:(state, payload)=>{
            const newShip={
                id_boat:payload.id_boat,
				enrollment:payload.enrollment,
                name_boat:payload.name_boat,
                trn:payload.trn,
                trb:payload.trb,
                detail_boat:payload.detail_boat,
                detail_propulsion:payload.detail_propulsion,
                factor_propulsion:payload.factor_propulsion,
                factor_navigate:payload.factor_navigate,
                factor_activity:payload.factor_activity,
                service:payload.service,
                type_service:payload.type_service,
                tarifa:payload.tarifa,
                kilos:payload.kilos,
                tonelada:payload.tonelada,
                litros:payload.litros,
                national_man:payload.national_man,
                national_woman:payload.national_woman,
                foreign_man:payload.foreign_man,
                foreign_woman:payload.foreign_woman,
                description_load:payload.description_load,
                flag:payload.flag,
                flag_boat:payload.flag_boat,
                type:payload.type,
                job_days:payload.job_days,
                date_zarpe:payload.date_zarpe,
                date_arrived:payload.date_arrived,
                factor_snh:payload.factor_snh,
                import_snh:payload.import_snh,
                quantity:payload.quantity,
                unit_id_quantity:payload.unit_id_quantity,
                unit_quantity:payload.unit_quantity,
                quantity_description:payload.quantity_description
            }
            let record = state.shipRegisters.findIndex(code=> code.enrollment===payload.enrollment);
            if(record<0){
                state.shipRegisters.unshift(newShip);
            }else{
                toastr.error('La nave que intenta ingresar ya esta registrada', 'Error')
            }            			
        },
        UPDATE_SHIP:(state, payload)=>{
            let job_days=state.dispatchDregde.job_days;
            let dredge=state.dispatchDregde.is_dredge;
            // console.log(`los dias de trabajo son ${job_days} y el dragado es ${dredge}`);
            let tempShip=state.shipRegisters;
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            // let total_form=0;            
            let aux_total=0;
            // state.shipRegisters=null;
            if(job_days > 0 && dredge){
                // es dragado
                for(let key in state.shipRegisters){
                    // calcular el valor de cut
                    let cut=fact_c / (1 + fact_a * Math.pow(state.shipRegisters[key].trb, (1 / fact_b) )) / 2.3;
                    
                    // let result= (cut*state.shipRegisters[key].trb*(state.dispatchFactor.navigate*state.shipRegisters[key].factor_propulsion*state.dispatchFactor.activity)+1)*state.ufv;
                    let result= (cut*state.shipRegisters[key].trb*(state.dispatchFactor.navigate*state.shipRegisters[key].factor_propulsion*state.shipRegisters[key].factor_activity)*job_days)*state.ufv;
                    // total_form=result.toFixed(1);
                    state.shipRegisters[key].factor_navigate=parseFloat(state.dispatchFactor.navigate);
                    // state.shipRegisters[key].factor_activity=parseFloat(state.dispatchFactor.activity);
                    state.shipRegisters[key].job_days=job_days;

                    let aux_result=result.toFixed(2);
                
                    let number_enter=Math.trunc(aux_result);
                    let number_decimal=Number((aux_result-number_enter).toFixed(2));
    
                    if(number_decimal===0.50){
                        result=aux_result;
                    }else if(number_decimal>0.50){
                        result=number_enter+1;
                    }else{                
                        result=number_enter;             
                    }
                    // colocar el import snh a 0 asi como el factor
                    state.shipRegisters[key].factor_snh=0;
                    state.shipRegisters[key].import_snh=0;
                    state.shipRegisters[key].tarifa=parseFloat(result);
                    aux_total+=result;
                }

            }else{
                // es normal el zarpe o atraque

                for(let key in state.shipRegisters){
                    // calcular el valor de cut
                    let cut=fact_c / (1 + fact_a * Math.pow(state.shipRegisters[key].trb, (1 / fact_b) )) / 2.3;
    
                    // let result= (cut*state.shipRegisters[key].trb*(state.dispatchFactor.navigate*state.shipRegisters[key].factor_propulsion*state.dispatchFactor.activity)+1)*state.ufv;
                    let result= ((cut*state.shipRegisters[key].trb*(state.dispatchFactor.navigate*state.shipRegisters[key].factor_propulsion*state.shipRegisters[key].factor_activity)+1)*state.ufv)*state.helpNavigationFactor;
                    // total_form=result.toFixed(1);
                    state.shipRegisters[key].factor_navigate=parseFloat(state.dispatchFactor.navigate);
                    // state.shipRegisters[key].factor_activity=parseFloat(state.dispatchFactor.activity);
                    
                    state.shipRegisters[key].job_days=job_days;        
                    
                    if(state.is_sindicate === 'S'){
                        if(parseInt(state.days_sindicate) > 0){
                            result=result*parseInt(state.days_sindicate);
                        }
                    }
                    
                    let aux_result=result.toFixed(2);
                
                    let number_enter=Math.trunc(aux_result);
                    let number_decimal=Number((aux_result-number_enter).toFixed(2));

                    if(number_decimal===0.50){
                        result=aux_result;
                    }else if(number_decimal>0.50){
                        result=number_enter+1;               
                    }else{                
                        result=number_enter;               
                    }
                    
                    let auxSnh= (result-(result/state.helpNavigationFactor)).toFixed(2);
                    state.shipRegisters[key].factor_snh=state.helpNavigationFactor;
                    state.shipRegisters[key].import_snh=auxSnh;
                    state.shipRegisters[key].tarifa=parseFloat(result);
                    aux_total+=result;
                }
            }

            
            state.total_dispatch=parseFloat(aux_total);
        },
        DELETE_SHIP:(state, payload)=>{
            let index = state.shipRegisters.findIndex(code => code.enrollment===payload );
            state.shipRegisters.splice(index,1);
        },
        REFRESH_SHIP:(state, payload)=>{
            state.shipRegisters=[];
        },
        ADD_SHIP_SANCION:(state, payload)=>{
            const newShip={
                id_boat:payload.id_boat,
				enrollment:payload.enrollment,
                name_boat:payload.name_boat,
                trn:payload.trn,
                trb:payload.trb,
                detail_boat:payload.detail_boat,
                detail_propulsion:payload.detail_propulsion,
                factor_propulsion:payload.factor_propulsion,
                factor_navigate:payload.factor_navigate,
                factor_activity:payload.factor_activity,
                service:payload.service,
                type_service:payload.type_service,
                tarifa:payload.tarifa,
                kilos:payload.kilos,
                tonelada:payload.tonelada,
                litros:payload.litros,
                national_man:payload.national_man,
                national_woman:payload.national_woman,
                foreign_man:payload.foreign_man,
                foreign_woman:payload.foreign_woman,
                description_load:payload.description_load,
                flag:payload.flag,
                flag_boat:payload.flag_boat,
                type:payload.type,
                job_days:payload.job_days,
                date_zarpe:payload.date_zarpe,
                date_arrived:payload.date_arrived,
                type_sancion:payload.type_sancion,
                number_relapse:payload.number_relapse,
                factor_relapse:payload.factor_relapse,
                id_track:payload.id_track
            }
            
            let record = state.shipRegistersSancion.findIndex(code=> code.enrollment===payload.enrollment);
            if(record<0){
                state.shipRegistersSancion.unshift(newShip);
            }else{
                toastr.error('La nave que intenta ingresar ya esta registrada', 'Error')
            }            			
        },
        UPDATE_SHIP_SANCION:(state, payload)=>{
                let fact_a=0.1;
                let fact_b=2;
                let fact_c=1.8;
                // let total_form=0;            
                let aux_total=0;
                // es normal el zarpe o atraque
                for(let key in state.shipRegistersSancion){
                    // calcular el valor de cut
                    let cut=fact_c / (1 + fact_a * Math.pow(state.shipRegistersSancion[key].trb, (1 / fact_b) )) / 2.3;
                    console.log(`el cut es ${cut}`);
                    // let result= (cut*state.shipRegistersSancion[key].trb*(state.dispatchFactor.navigate*state.shipRegistersSancion[key].factor_propulsion*state.dispatchFactor.activity)+1)*state.ufv;
                    
                    // MD=fmd*r*U*(1+N*P*A*T*C)
                    // result= 1.1 * this.penalty_dts.factor_relapse * this.ufv_sancion * (1 + this.navegacion_sub_sancion.factor * factPropulsion * this.actividad_sancion.factor *this.boatLocal.trb * this.changeCUT);

                    let result= 1.1 * state.shipRegistersSancion[key].factor_relapse * state.ufv * (1 + state.dispatchFactorSancion.navigate * state.shipRegistersSancion[key].factor_propulsion * state.shipRegistersSancion[key].factor_activity *state.shipRegistersSancion[key].trb * cut);

                    // console.log(`el valor de factor relapse es ${state.shipRegistersSancion[key].factor_relapse}`);
                    // console.log(`el valor de factor navegacion es ${state.dispatchFactorSancion.navigate}`);
                    // console.log(`el valor de factor propulsion es ${state.shipRegistersSancion[key].factor_propulsion}`);
                    // console.log(`el valor de factor actividad es ${state.shipRegistersSancion[key].factor_activity}`);
                    // console.log(`el valor del TRB es ${state.shipRegistersSancion[key].trb}`);

                    state.shipRegistersSancion[key].factor_navigate=parseFloat(state.dispatchFactorSancion.navigate);
                    // state.shipRegistersSancion[key].factor_activity=parseFloat(state.dispatchFactor.activity);
                    

                    let aux_result=result.toFixed(2);
                    console.log(`el resultado de la naves es ${aux_result}`);
                    let number_enter=Math.trunc(aux_result);
                    let number_decimal=Number((aux_result-number_enter).toFixed(2));
    
                    if(number_decimal===0.50){
                        result=aux_result;
                    }else if(number_decimal>0.50){
                        result=number_enter+1;               
                    }else{                
                        result=number_enter;               
                    }
    
                    state.shipRegistersSancion[key].tarifa=parseFloat(result);
                    aux_total+=result;
                }
            
            state.total_dispatch_sancion=parseFloat(aux_total);
        },
        DELETE_SHIP_SANCION:(state, payload)=>{
            let index = state.shipRegistersSancion.findIndex(code => code.enrollment===payload );
            state.shipRegistersSancion.splice(index,1);
        },
        REFRESH_SHIP_SANCION:(state, payload)=>{
            state.shipRegistersSancion=[];
        },
        UPDATE_DISABLED:(state, payload)=>{
            state.disabled_global=payload;
        },
        UPDATE_TITLE_DISPATCH:(state, payload)=>{
            state.title_dispatch=payload;
        },
        SESSION_INIT:(state, payload)=>{
            state.userState.nick=payload.nick;
            state.userState.portId=payload.idPort;
            state.userState.name_port=payload.portName;
            state.userState.category_port=payload.categoryPort;
            state.userState.role=payload.category;
            state.userState.roleAssign=payload.role;
        },
        SESSION_DESTROY:(state, payload)=>{
            state.userState.id=null;
            state.userState.nick=null;
            state.userState.portId=null;
            state.userState.name_port=null;
            state.userState.role=null;
            state.userState.roleAssign=null;
        }
    },
    actions:{
        addIsSindicate:(context, payload)=>{
            context.commit('ADD_IS_SINDICATE', payload);
        },
        addDaysSindicate:(context, payload)=>{
            context.commit('ADD_DAYS_SINDICATE', payload);
        },
        addHelpNavigation:(context, payload)=>{
            context.commit('ADD_HELP_NAVIGATION', payload);
        },
        addBoat:(context, payload)=>{
            context.commit('ADD_BOAT', payload)
        },
        deleteBoat:(context, payload)=>{
            context.commit('DELETE_BOAT', payload)
        },
        deleteBoatSancion:(context, payload)=>{
            context.commit('DELETE_BOAT_SANCION', payload)
        },
        addFactor:(context, payload)=>{
            context.commit('ADD_FACTOR', payload)
        },
        deleteFactor:(context, payload)=>{
            context.commit('DELETE_FACTOR', payload)
        },
        addFactorSancion:(context, payload)=>{
            context.commit('ADD_FACTOR_SANCION', payload)
        },
        deleteFactorSancion:(context, payload)=>{
            context.commit('DELETE_FACTOR_SANCION', payload)
        },
        addDredge:(context, payload)=>{
            context.commit('ADD_DREDGE', payload)
        },
        deleteDregde:(context, payload)=>{
            context.commit('DELETE_DREDGE', payload)
        },        
        addShip:(context, payload)=>{
            context.commit('ADD_SHIP', payload)
        },
        deleteShip:(context, payload)=>{
            context.commit('DELETE_SHIP', payload)
        },
        updateShip:(context, payload)=>{
            context.commit('UPDATE_SHIP', payload)
        },
        refreshShip:(context,payload)=>{
            context.commit('REFRESH_SHIP', payload)
        },
        addShipSancion:(context, payload)=>{
            context.commit('ADD_SHIP_SANCION', payload)
        },
        deleteShipSancion:(context, payload)=>{
            context.commit('DELETE_SHIP_SANCION', payload)
        },
        updateShipSancion:(context, payload)=>{
            context.commit('UPDATE_SHIP_SANCION', payload)
        },
        refreshShipSancion:(context,payload)=>{
            context.commit('REFRESH_SHIP_SANCION', payload)
        },
        addUFV:(context, payload)=>{
            context.commit('ADD_UFV', payload)
        },
        changeDisabled:(context, payload)=>{
            context.commit('UPDATE_DISABLED', payload)
        },
        addTitleDispatch:(context, payload)=>{
            context.commit('UPDATE_TITLE_DISPATCH', payload)
        },
        sessionInit:(context,payload)=>{
            context.commit('SESSION_INIT', payload)
        },
        sessionDestroy:(context, payload)=>{
            context.commit('SESSION_DESTROY', payload)
        }
    }
}

const sShipPendingEnrollment={
    namespaced:true,
    state:{
        sEnrollmentShipPending:{
            id_maestro:null,
            id_detalle:null,
            id_propietario:null,
            id_tramite:null,
            nombre:null,
            tipo_embarcacion:null,
            propulsion:null,
            correlativo:null,
            anio:null,
            importe_tramite:null,
            material_construccion:null,
            destino_navegacion:null,
            trb:null,
            trn:null,
            eslora:null,
            manga:null,
            puntal:null,
            calado:null,
            anio_construccion:null,
            lugar_construccion:null,
            costo_construccion:null,
            destino_embarcacion:null,
            nombre_propietario:null,
            tipo_identificacion:null,
            dato_identificacion:null,
            expedido:null,
            nacionalidad:null,
            domicilio:null,
            celular:null,
            telefono_fijo:null,
            representante_legal:null,
            parameters_traffic:null,
            date_r:null
        }
    },
    getters:{
        getEnrollmentPendingShip(state){
            return state.sEnrollmentShipPending;
        }
    },
    mutations:{
        ADD_SHIP_PENDING_ENROLLMENT:(state, payload)=>{
            state.sEnrollmentShipPending.id_maestro=payload.id_maestro;
            state.sEnrollmentShipPending.id_detalle=payload.id_detalle;
            state.sEnrollmentShipPending.id_propietario=payload.id_propietario;
            state.sEnrollmentShipPending.id_tramite=payload.id_tramite;
            state.sEnrollmentShipPending.nombre=payload.nombre;
            state.sEnrollmentShipPending.tipo_embarcacion=payload.tipo_embarcacion;
            state.sEnrollmentShipPending.propulsion=payload.propulsion;
            state.sEnrollmentShipPending.correlativo=payload.correlativo;
            state.sEnrollmentShipPending.anio=payload.anio;
            state.sEnrollmentShipPending.importe_tramite=parseFloat(payload.importe_tramite).toFixed(2);
            state.sEnrollmentShipPending.material_construccion=payload.material_construccion;
            state.sEnrollmentShipPending.destino_navegacion=payload.destino_navegacion;
            state.sEnrollmentShipPending.trb=payload.trb;
            state.sEnrollmentShipPending.trn=payload.trn;
            state.sEnrollmentShipPending.eslora=payload.eslora;
            state.sEnrollmentShipPending.manga=payload.manga;
            state.sEnrollmentShipPending.puntal=payload.puntal;
            state.sEnrollmentShipPending.calado=payload.calado;
            state.sEnrollmentShipPending.anio_construccion=payload.anio_construccion;
            state.sEnrollmentShipPending.lugar_construccion=payload.lugar_construccion;
            state.sEnrollmentShipPending.costo_construccion=payload.costo_construccion;
            state.sEnrollmentShipPending.destino_embarcacion=payload.destino_embarcacion;
            state.sEnrollmentShipPending.nombre_propietario=payload.nombre_propietario;
            state.sEnrollmentShipPending.tipo_identificacion=payload.tipo_identificacion;
            state.sEnrollmentShipPending.dato_identificacion=payload.dato_identificacion;
            state.sEnrollmentShipPending.expedido=payload.expedido;
            state.sEnrollmentShipPending.nacionalidad=payload.nacionalidad;
            state.sEnrollmentShipPending.domicilio=payload.domicilio;
            state.sEnrollmentShipPending.celular=payload.celular;
            state.sEnrollmentShipPending.telefono_fijo=payload.telefono_fijo;
            state.sEnrollmentShipPending.representante_legal=payload.representante_legal;
            state.sEnrollmentShipPending.parameters_traffic=payload.parameters_traffic;
            state.sEnrollmentShipPending.date_r=payload.date_reg;
            // state.sEnrollmentShipPending=payload;
        },
        DELETE_SHIP_PENDING_ENROLLMENT:(state, payload)=>{
            state.sEnrollmentShipPending={
                id_maestro:null,
                id_detalle:null,
                id_propietario:null,
                nombre:null,
                tipo_embarcacion:null,
                propulsion:null,
                correlativo:null,
                anio:null,
                importe_tramite:null,
                material_construccion:null,
                destino_navegacion:null,
                trb:null,
                trn:null,
                eslora:null,
                manga:null,
                puntal:null,
                calado:null,
                anio_construccion:null,
                lugar_construccion:null,
                costo_construccion:null,
                destino_embarcacion:null,
                nombre_propietario:null,
                tipo_identificacion:null,
                dato_identificacion:null,
                expedido:null,
                nacionalidad:null,
                domicilio:null,
                celular:null,
                telefono_fijo:null,
                representante_legal:null,
                parameters_traffic:null,
                date_r:null
            };
        }
    },
    actions:{
        addShipPendingEnrollment:(context, payload)=>{
            context.commit('ADD_SHIP_PENDING_ENROLLMENT', payload);
        },
        deleteShipPendingEnrollment:(context, payload)=>{
            context.commit('DELETE_SHIP_PENDING_ENROLLMENT', payload);
        }
    }
}

const sAuxShipPendingEnrollment={
    namespaced:true,
    state:{        
        sAuxEnrollmentShipPending:{
            id_maestro:null,
            id_detalle:null,
            id_propietario:null,
            id_tramite:null,
            nombre:null,
            tipo_embarcacion:null,
            propulsion:null,
            correlativo:null,
            anio:null,
            importe_tramite:null,
            material_construccion:null,
            destino_navegacion:null,
            trb:null,
            trn:null,
            eslora:null,
            manga:null,
            puntal:null,
            calado:null,
            anio_construccion:null,
            lugar_construccion:null,
            costo_construccion:null,
            destino_embarcacion:null,
            nombre_propietario:null,
            tipo_identificacion:null,
            dato_identificacion:null,
            expedido:null,
            nacionalidad:null,
            domicilio:null,
            celular:null,
            telefono_fijo:null,
            representante_legal:null,
            parameters_traffic:null,
            date_r:null
        }
    },
    getters:{        
        getAuxEnrollmentPendingShip(state){
            return state.sAuxEnrollmentShipPending;
        }
    },
    mutations:{
        ADD_AUX_SHIP_PENDING_ENROLLMENT:(state, payload)=>{
            state.sAuxEnrollmentShipPending.id_maestro=payload.id_maestro;
            state.sAuxEnrollmentShipPending.id_detalle=payload.id_detalle;
            state.sAuxEnrollmentShipPending.id_propietario=payload.id_propietario;
            state.sAuxEnrollmentShipPending.id_tramite=payload.id_tramite;
            state.sAuxEnrollmentShipPending.nombre=payload.nombre;
            state.sAuxEnrollmentShipPending.tipo_embarcacion=payload.tipo_embarcacion;
            state.sAuxEnrollmentShipPending.propulsion=payload.propulsion;
            state.sAuxEnrollmentShipPending.correlativo=payload.correlativo;
            state.sAuxEnrollmentShipPending.anio=payload.anio;
            state.sAuxEnrollmentShipPending.importe_tramite=parseFloat(payload.importe_tramite).toFixed(2);
            state.sAuxEnrollmentShipPending.material_construccion=payload.material_construccion;
            state.sAuxEnrollmentShipPending.destino_navegacion=payload.destino_navegacion;
            state.sAuxEnrollmentShipPending.trb=payload.trb;
            state.sAuxEnrollmentShipPending.trn=payload.trn;
            state.sAuxEnrollmentShipPending.eslora=payload.eslora;
            state.sAuxEnrollmentShipPending.manga=payload.manga;
            state.sAuxEnrollmentShipPending.puntal=payload.puntal;
            state.sAuxEnrollmentShipPending.calado=payload.calado;
            state.sAuxEnrollmentShipPending.anio_construccion=payload.anio_construccion;
            state.sAuxEnrollmentShipPending.lugar_construccion=payload.lugar_construccion;
            state.sAuxEnrollmentShipPending.costo_construccion=payload.costo_construccion;
            state.sAuxEnrollmentShipPending.destino_embarcacion=payload.destino_embarcacion;
            state.sAuxEnrollmentShipPending.nombre_propietario=payload.nombre_propietario;
            state.sAuxEnrollmentShipPending.tipo_identificacion=payload.tipo_identificacion;
            state.sAuxEnrollmentShipPending.dato_identificacion=payload.dato_identificacion;
            state.sAuxEnrollmentShipPending.expedido=payload.expedido;
            state.sAuxEnrollmentShipPending.nacionalidad=payload.nacionalidad;
            state.sAuxEnrollmentShipPending.domicilio=payload.domicilio;
            state.sAuxEnrollmentShipPending.celular=payload.celular;
            state.sAuxEnrollmentShipPending.telefono_fijo=payload.telefono_fijo;
            state.sAuxEnrollmentShipPending.representante_legal=payload.representante_legal;
            state.sAuxEnrollmentShipPending.parameters_traffic=payload.parameters_traffic;
            state.sAuxEnrollmentShipPending.date_r=payload.date_reg;
        },
        DELETE_AUX_SHIP_PENDING_ENROLLMENT:(state, payload)=>{
            state.sAuxEnrollmentShipPending={
                id_maestro:null,
                id_detalle:null,
                id_propietario:null,
                id_tramite:null,
                nombre:null,
                tipo_embarcacion:null,
                propulsion:null,
                correlativo:null,
                anio:null,
                importe_tramite:null,
                material_construccion:null,
                destino_navegacion:null,
                trb:null,
                trn:null,
                eslora:null,
                manga:null,
                puntal:null,
                calado:null,
                anio_construccion:null,
                lugar_construccion:null,
                costo_construccion:null,
                destino_embarcacion:null,
                nombre_propietario:null,
                tipo_identificacion:null,
                dato_identificacion:null,
                expedido:null,
                nacionalidad:null,
                domicilio:null,
                celular:null,
                telefono_fijo:null,
                representante_legal:null,
                parameters_traffic:null,
                date_r:null
            };
        }        
    },
    actions:{
        addAuxShipPendingEnrollment:(context, payload)=>{
            context.commit('ADD_AUX_SHIP_PENDING_ENROLLMENT', payload);
        },
        deleteAuxShipPendingEnrollment:(context, payload)=>{
            context.commit('DELETE_AUX_SHIP_PENDING_ENROLLMENT', payload);
        }       
    }
}

const sDebtsPending={
    namespaced:true,
    state:{
        debtsStore:[]
    },
    getters:{
        getDebtsPending(state){
            return state.debtsStore;
        },
        getDebtsTotal(state){
            let total_global=0;
            if(state.debtsStore.length > 0){
                state.debtsStore.forEach(reg => {
                    total_global+=reg.total;
                });
            }else{
                total_global=0;
            }
            return total_global.toFixed(2);
        }
    },
    mutations:{
        ADD_DTS_DEBTS_PENDING:(state, payload) => {
            const newDebts = {
                idDownload:payload.id_download,
                operation:payload.operation,
                responsability:payload.responsability,
                correlative:payload.correlative,
                anio:payload.anio,
                total:parseFloat(payload.total),
                module:payload.module,
                port:payload.port,
                select:true,
                dateDoc:payload.date_document
            }
            state.debtsStore.unshift(newDebts);
        },
        DELETE_DTS_DEBTS_PENDING:(state, payload)=>{
            let index = state.debtsStore.findIndex( (item) => parseInt(item.idDownload) === parseInt(payload))
            state.debtsStore.splice(index, 1)            
        },
        CLEAR_DTS_DEBTS_PENDING:(state, payload)=>{
            state.debtsStore=[]
        }
    },
    actions:{
        addDebts:(context,payload)=>{
            context.commit('ADD_DTS_DEBTS_PENDING', payload);
        },
        deleteItemDebts:(context, payload)=>{
            context.commit('DELETE_DTS_DEBTS_PENDING', payload);
        },
        clearDebts:(context,payload)=>{
            context.commit('CLEAR_DTS_DEBTS_PENDING', payload);
        }
    }
}

const sDocumentsDebts={
    namespaced:true,
    state:{
        documentsDebts:[]
    },
    getters:{
        getDocumentsDebts(state){
            return state.documentsDebts;
        },
        getDocumentDebtT(state){
            let totalDocuments=0;
            if(state.documentsDebts.length > 0){
                state.documentsDebts.forEach(reg => {
                    totalDocuments+=reg.importe;
                });
            }else{
                totalDocuments=0;
            }
            return totalDocuments.toFixed(2);
        }
    },
    mutations:{
        ADD_DTS_DOCUMENT_DBT:(state, payload) => {
            let auxId= (state.documentsDebts.length)+1;
            const newDocum = {
                idDischarge:auxId,
                chanelId:payload.idChanel,
                chanelDescription:payload.detailChanel,
                documentId:payload.idDocument,
                documentDescription:payload.detailDocument,
                documentNumber:payload.numberDoc,
                documentDate:payload.dateDoc,
                importe:parseFloat(payload.importe)
            }
            state.documentsDebts.unshift(newDocum);
        },
        DELETE_DTS_DOCUMENT_DBT:(state, payload)=>{
            let index = state.documentsDebts.findIndex( (item) => parseInt(item.idDischarge) === parseInt(payload))
            state.documentsDebts.splice(index, 1)            
        },
        CLEAR_DTS_DOCUMENT_DBT:(state, payload)=>{
            state.documentsDebts=[]
        }
    },
    actions:{
        addDocument:(context,payload)=>{
            context.commit('ADD_DTS_DOCUMENT_DBT', payload);
        },
        deleteDocument:(context, payload)=>{
            context.commit('DELETE_DTS_DOCUMENT_DBT', payload);
        },
        clearDocument:(context,payload)=>{
            context.commit('CLEAR_DTS_DOCUMENT_DBT', payload);
        }
    }
}

const sRenewShip={
    namespaced:true,
    state:{
        shipRenew:[]
    },
    getters:{
        getShipRenew(state){
            return state.shipRenew;
        }
    },
    mutations:{
        ADD_SHIP_RENEW:(state, payload) => {
            state.shipRenew=payload;
        },
        DELETE_SHIP_RENEW:(state, payload)=>{
            state.shipRenew=[];
        }
    },
    actions:{
        addShipRenew:(context,payload)=>{
            context.commit('ADD_SHIP_RENEW', payload);
        },
        deleteShipRenew:(context, payload)=>{
            context.commit('DELETE_SHIP_RENEW', payload);
        }
    }
}

const sGoogleMaps={
    namespaced:true,
    state:{        
        markerNew: [
            {
                index:"0",
                position: { lat: -14.870719, lng: -64.967 },
                title:'Nueva Ubicacion'
            }
        ],
        markerUpdateCaptain:{
            lat:0,
            lng:0
        },
        markersCaptains:[],
        markersJurisdiccion:[]
    },
    getters:{
        getLocation(state){
            return state.markerNew;
        },
        getLocationPosition(state){
            return state.markerUpdateCaptain;
        },
        getMarkersCaptain(state){
            return state.markersCaptains;
        },
        getMarkersJurisdiccion(state){
            return state.markersJurisdiccion;
        }
    },
    mutations:{
        ADD_NEW_LOCATION:(state, payload) => {
            state.markerNew=[];
            state.markerNew.push(payload);
        },
        ADD_NEW_LOCATION_POSITION:(state, payload)=>{
            state.markerUpdateCaptain.lat=payload.lat;
            state.markerUpdateCaptain.lng=payload.lng;
        },
        ADD_MARKS_CAPTAINS:(state, payload)=>{
            state.markersCaptains=payload;
        },
        DELETE_MARKS_CAPTAINS:(state, payload)=>{
            state.markersCaptains=[];
        },
        ADD_MARKS_JURISDICCION:(state, payload)=>{
            state.markersJurisdiccion=payload;
        },
        ADD_NEW_MARK_JURISDICCION:(state, payload)=>{
            // console.log(state.markersJurisdiccion);
            let imark=state.markersJurisdiccion.findIndex(vl => (vl.position.lat === payload.position.lat && vl.position.lng === payload.position.lng));
            if(imark === -1){
                state.markersJurisdiccion.push(payload);
            }
        },
        DELETE_MARKS_JURISDICCION:(state, payload)=>{
            let im=state.markersJurisdiccion.findIndex( mc => mc.id === payload);
            if(im >-1 ){
                // si encuentra el valor elimina la posicion
                state.markersJurisdiccion.splice(im,1);
            }            
        },
        EDIT_MARKER_JURISDICCION:(state, payload)=>{
            let ie=state.markersJurisdiccion.findIndex( mc => mc.id === payload);
            state.markersJurisdiccion[ie].edit=true;
        },
        CANCEL_EDIT_MARKER_JURISDICCION:(state, payload)=>{
            // let ie=state.markersJurisdiccion.findIndex( mc => mc.id === payload);
            state.markersJurisdiccion.forEach(v=>{
                v.edit=false;
            });
        },
        DELETE_ALL_MARKS_JURISDICCION:(state, payload)=>{
            state.markersJurisdiccion=[];
        },
        SAVE_MARKER_JURISDICCION:(state, payload)=>{
            let ie=state.markersJurisdiccion.findIndex( mc => mc.id === payload.id);
            state.markersJurisdiccion[ie].localidad=payload.localidad;
            state.markersJurisdiccion[ie].description=payload.description;
            state.markersJurisdiccion[ie].edit=false;
        }
    },
    actions:{
        addNewPosition:(context,payload)=>{
            context.commit('ADD_NEW_LOCATION', payload);
        },
        addNewPositionLocation:(context, payload)=>{
            context.commit('ADD_NEW_LOCATION_POSITION',payload);
        },
        addMarkersCaptains:(context, payload)=>{
            context.commit('ADD_MARKS_CAPTAINS', payload);
        },
        deleteMarkersCaptains:(context, payload)=>{
            context.commit('DELETE_MARKS_CAPTAINS', payload);
        },
        addMarkersJurisdiccion:(context, payload)=>{
            context.commit('ADD_MARKS_JURISDICCION', payload);
        },
        addNewMarkJurisdiccion:(context, payload)=>{
            context.commit('ADD_NEW_MARK_JURISDICCION', payload);
        },
        editMarkerJurisdiccion:(context, payload)=>{
            context.commit('EDIT_MARKER_JURISDICCION', payload);
        },
        cancelEditMarkerJurisdiccion:(context, payload)=>{
            context.commit('CANCEL_EDIT_MARKER_JURISDICCION', payload);
        },
        deleteMarkersJurisdiccion:(context, payload)=>{
            context.commit('DELETE_MARKS_JURISDICCION', payload);
        },
        deleteAllMarkersjurisdiccion:(context, payload)=>{
            context.commit('DELETE_ALL_MARKS_JURISDICCION', payload);
        },
        saveMarkerJurisdiccion:(context, payload)=>{
            context.commit('SAVE_MARKER_JURISDICCION', payload);
        }
    }
}

const sComplaintsPersons={
    namespaced:true,
    state:{
        personComplaint:[]
    },
    getters:{
        getPersonComplaint(state){
            return state.personComplaint;
        }
    },
    mutations:{
        ADD_PERSON_COMPLAINT:(state, payload) => {
            // buscar si ya existe el registro con la condicion de D, V, S
            let per_aux=state.personComplaint.findIndex(pc => (pc.id_person === payload.id_person && pc.type_select === payload.type_select));
            if(per_aux === -1){
                state.personComplaint.push(payload);
            }else{
                toastr.warning('No se puede asignar dos veces a la misma persona por la misma causa', 'Advertencia');
            }
            
        },
        DELETE_PERSON_COMPLAINT:(state, payload)=>{
            let per_aux=state.personComplaint.findIndex(pc => (pc.id_person === payload.id_person && pc.type_select === payload.type_select));
            if(per_aux>=0){
                state.personComplaint.splice(per_aux,1);
            }            
        },
        DELETE_PERSONS_TYPE:(state, payload)=>{
            let countV=0;
            state.personComplaint.forEach( (pd, index) =>{
                if(pd.type_select === payload){
                    countV++;
                }
            })
            
            for(let i = 0;i<countV ; i++ ){
                let pos_aux=state.personComplaint.findIndex(pc => ( pc.type_select === payload));            
                state.personComplaint.splice(pos_aux,1);
            }
        }
    },
    actions:{
        addPersonComplaint:(context,payload)=>{
            context.commit('ADD_PERSON_COMPLAINT', payload);
        },
        deletePersonComplaint:(context, payload)=>{
            context.commit('DELETE_PERSON_COMPLAINT', payload);
        },
        deletePersonsType:(context, payload)=>{
            context.commit('DELETE_PERSONS_TYPE', payload);
        }
    }
}

const sComplaintsPersonsEdit={
    namespaced:true,
    state:{
        personComplaintEdit:[]
    },
    getters:{
        getPersonComplaintEdit(state){
            return state.personComplaintEdit;
        }
    },
    mutations:{
        ADD_PERSON_COMPLAINT_EDIT:(state, payload) => {
            // buscar si ya existe el registro con la condicion de D, V, S
            let per_aux=state.personComplaintEdit.findIndex(pc => (pc.id_person === payload.id_person && pc.type_select === payload.type_select));
            if(per_aux === -1){
                state.personComplaintEdit.push(payload);
            }else{
                toastr.warning('No se puede asignar dos veces a la misma persona por la misma causa', 'Advertencia');
            }
            
        },
        DELETE_PERSON_COMPLAINT_EDIT:(state, payload)=>{
            let per_aux=state.personComplaintEdit.findIndex(pc => (pc.id_person === payload.id_person && pc.type_select === payload.type_select));
            if(per_aux>=0){
                state.personComplaintEdit.splice(per_aux,1);
            }            
        },
        DELETE_PERSON_COMPLAINT_SPECIFY:(state, payload)=>{
            state.personComplaintEdit.splice(payload,1);
        },
        DELETE_PERSONS_TYPE_EDIT:(state, payload)=>{
            let countV=0;
            state.personComplaintEdit.forEach( (pd, index) =>{
                if(pd.type_select === payload){
                    countV++;
                }
            })
            
            for(let i = 0;i<countV ; i++ ){
                let pos_aux=state.personComplaintEdit.findIndex(pc => ( pc.type_select === payload));            
                state.personComplaintEdit.splice(pos_aux,1);
            }
        }
    },
    actions:{
        addPersonComplaintEdit:(context,payload)=>{
            context.commit('ADD_PERSON_COMPLAINT_EDIT', payload);
        },
        deletePersonComplaintEdit:(context, payload)=>{
            context.commit('DELETE_PERSON_COMPLAINT_EDIT', payload);
        },
        deletePersonComplaintSpecifyEdit:(context, payload)=>{
            context.commit('DELETE_PERSON_COMPLAINT_SPECIFY', payload);
        },
        deletePersonsTypeEdit:(context, payload)=>{
            context.commit('DELETE_PERSONS_TYPE_EDIT', payload);
        }
    }
}

const sChargesSecondary={
    namespaced:true,
    state:{
        chargesSecondary:[]
    },
    getters:{
        getChargeSec(state){
            return state.chargesSecondary;
        }
    },
    mutations:{
        ADD_NEW_CHARGE_SECONDARY:(state, payload) => {
            // buscar si ya existe el registro con la condicion de D, V, S
            let charge_aux=state.chargesSecondary.findIndex(ca => (ca.id_load === payload.id_load ));
            if(charge_aux === -1){
                state.chargesSecondary.push(payload);
            }else{
                toastr.warning('No se puede asignar dos veces a la misma persona por la misma causa', 'Advertencia');
            }
            
        },
        DELETE_CHARGE_SECONDARY:(state, payload)=>{
            let charge_aux=state.chargesSecondary.findIndex(ca => (ca.id_load === payload.id_load ));
            if(charge_aux>=0){
                state.chargesSecondary.splice(charge_aux,1);
            }            
        },
        DELETE_CHARGE_CLEAR:(state, payload)=>{
            state.chargesSecondary=[];
        }
    },
    actions:{
        addChargeSecondary:(context,payload)=>{
            context.commit('ADD_NEW_CHARGE_SECONDARY', payload);
        },
        deleteChargeSecondary:(context, payload)=>{
            context.commit('DELETE_CHARGE_SECONDARY', payload);
        },
        deleteChargeClear:(context, payload)=>{
            context.commit('DELETE_CHARGE_CLEAR', payload);
        }
    }
}

const sListPersonDispatch={
    namespaced:true,
    state:{
        listPersons:[]
    },
    getters:{
        getListPersons(state){
            return state.listPersons;
        }
    },
    mutations:{
        ADD_NEW_PERSON:(state, payload) => {
            let charge_aux=state.listPersons.findIndex(ca => (ca.document === payload.document ));
            if(charge_aux === -1){
                state.listPersons.push(payload);
            }else{
                toastr.warning('No se puede asignar dos veces a la misma persona', 'Advertencia');
            }            
        },
        DELETE_PERSON:(state, payload)=>{
            let charge_aux=state.listPersons.findIndex(ca => (ca.document === payload ));
            if(charge_aux>=0){
                state.listPersons.splice(charge_aux,1);
            }            
        },
        DELETE_PERSON_ALL:(state, payload)=>{
            state.listPersons=[];
        }
    },
    actions:{
        addPersonList:(context,payload)=>{
            context.commit('ADD_NEW_PERSON', payload);
        },
        deletePerson:(context, payload)=>{
            context.commit('DELETE_PERSON', payload);
        },
        deletePersonAll:(context, payload)=>{
            context.commit('DELETE_PERSON_ALL', payload);
        }
    }
}

const sPasavantOficial={
    namespaced:true,
    state:{
        shipPasavant:[],
        ownerPasavant:[],
        enginePasavant:[]
    },
    getters:{
        getShipPasavant(state){
            return state.shipPasavant;
        },
        getOwnerPasavant(state){
            return state.ownerPasavant;
        },
        getEnginePasavant(state){
            return state.enginePasavant;
        }
    },
    mutations:{
        ADD_SHIP_PASAVANT:(state, payload) => {
            state.shipPasavant=payload;
        },
        DELETE_SHIP_PASAVANT:(state, payload)=>{
            state.shipPasavant=[];
        },
        ADD_OWNER_PASAVANT:(state, payload)=>{
            state.ownerPasavant=payload;
        },
        DELETE_OWNER_PASAVANT:(state, payload)=>{
            state.ownerPasavant=[];
        },
        ADD_ENGINE_PASAVANT:(state, payload)=>{
            state.enginePasavant=payload;
        },
        DELETE_ENGINE_PASAVANT:(state, payload)=>{
            state.enginePasavant=[];
        }
    },
    actions:{
        addShipPasavant:(context,payload)=>{
            context.commit('ADD_SHIP_PASAVANT', payload);
        },
        deleteShipPasavant:(context, payload)=>{
            context.commit('DELETE_SHIP_PASAVANT', payload);
        },
        addOwnerPasavant:(context, payload)=>{
            context.commit('ADD_OWNER_PASAVANT', payload);
        },
        deleteOwnerPasavant:(context, payload)=>{
            context.commit('DELETE_OWNER_PASAVANT', payload);
        },
        addEnginePasavant:(context, payload)=>{
            context.commit('ADD_ENGINE_PASAVANT', payload);
        },
        deleteEnginePasavant:(context, payload)=>{
            context.commit('DELETE_ENGINE_PASAVANT', payload);
        }
    }
}

export default new Vuex.Store({
    // plugins: [createPersistedState()],
    modules:{
       oldMeth:oldMethod,
       sShipEnrollmentP:sShipPendingEnrollment,
       sAuxShipEnrollmentP:sAuxShipPendingEnrollment,
       sDebtsP:sDebtsPending,
       sDocDebts:sDocumentsDebts,
       sShipRenew:sRenewShip,
       sGoogleMaps:sGoogleMaps,
       sComplaintsPersons:sComplaintsPersons,
       sComplaintsPersonsEdit:sComplaintsPersonsEdit,
       sChargesSecondary:sChargesSecondary,
       sListPersonDispatch:sListPersonDispatch,
       sPasavantOf:sPasavantOficial
   }
})


// WEBPACK FOOTER //
// ./src/store/index.js